"use client";

import React from "react";
import HomePageMobile from "@/components/pages/home/home-page-mobile";
import HomePage from "@/components/pages/home/home-page";
import { useMobile } from "@/hooks/use-responsive";
import { CategoriesDropdownProvider } from "@/components/pages/home/providers/categories-dropdown-provider";
import { GenderDropdownProvider } from "@/components/pages/home/providers/gender-dropdown-provider";

const MainHome = () => {
  const { isMobile } = useMobile();
  return (
    <CategoriesDropdownProvider>
      <GenderDropdownProvider>
        {/*{isMobile ? <HomePageMobile /> : <HomePage />}*/}
        <HomePage />
      </GenderDropdownProvider>
    </CategoriesDropdownProvider>
  );
};

export default MainHome;
